export default __webpack_public_path__ + "static/media/prodimg-jola-1.a9e2f827.png";